// Centralized ID generation utility
// Single source of truth for generating unique identifiers

/**
 * Generate a unique ID using timestamp + random string
 * Format: {timestamp}-{random7chars}
 * Example: 1699543210123-a1b2c3d
 */
export function generateId(): string {
  return `${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
}

/**
 * Generate an ID with a prefix
 * @param prefix - Prefix for the ID (e.g., 'bf', 'bore', 'circuit')
 * @returns Prefixed unique ID (e.g., 'bf-1699543210123-a1b2c3d')
 */
export function generatePrefixedId(prefix: string): string {
  return `${prefix}-${generateId()}`;
}
